module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Difference-9d0ec1da52c5bb7393660bce3123599e.svg";